import React from 'react';
import Footer from './Footer';
import Breadcrumbs from './Breadcrumbs';

const Layout = ({ children, showBreadcrumbs = true }) => {
  return (
    <div className="min-h-screen flex flex-col app-shell-bg">
      <main className="flex-1">
        {showBreadcrumbs && <Breadcrumbs />}
        {children}
      </main>
      
      <Footer />
    </div>
  );
};

export default Layout;
